import d3Tip, { Tooltip } from 'd3-tip';
import type * as dc from 'dc';
import { get } from 'lodash';

export interface IDCTooltip {
  render(chart: dc.BaseMixin<unknown>): void;
  destroy(): void;
}

export class DCTooltip implements IDCTooltip {
  private _tooltip: Tooltip;
  private _events?: unknown;

  constructor(
    private _hoverElementTarget: string,
    private _labelFn: (data: unknown) => string,
    private _valueFn: (data: unknown) => string
  ) {
    this._tooltip = d3Tip()
      .attr('class', 'd3-tip')
      .offset([-10, 0])
      .html((event: MouseEvent) => {
        const data: unknown = get(event.target, '__data__', {});
        const label = this._labelFn(data);
        const val = this._valueFn(data);
        return `<div class="tooltip">
          <div class="label">${label}</div>
          <div class="value">${val}</div>
        </div>`;
      });
  }

  render(chart: dc.BaseMixin<unknown>): void {
    if (this._events) {
      return;
    }

    this._events = chart.on('postRender', (event) => {
      (event as dc.BaseMixin<unknown>)
        .selectAll(this._hoverElementTarget)
        .call(this._tooltip)
        .on('mouseover', this._tooltip.show)
        .on('mouseout', this._tooltip.hide);
    });
  }

  destroy(): void {
    this._tooltip.destroy();
  }
}
